<script setup lang="ts">
import { useMessenger } from '../composables/useMessenger'
import type { CommunicationItem } from '../types/communication'

import CommunicationDetailDialog from './CommunicationDetailDialog.vue'

const messenger = useMessenger()

function handleMemoReply(memo: CommunicationItem) {
  messenger.isMemoDialogOpen = false
  void messenger.openRecipientChat(memo.id)
}

function handleAcknowledged(communicationId: string) {
  messenger.notifyRecipientStateChanged(communicationId, 'acknowledged')
}
</script>

<template>
  <CommunicationDetailDialog
    v-model:open="messenger.isMemoDialogOpen"
    :memo="messenger.memoToView"
    @reply="handleMemoReply"
    @acknowledged="handleAcknowledged"
  />
</template>
